import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'topo-severity-bar',
  templateUrl: './severity-bar.component.html',
  styleUrls: ['./severity-bar.component.scss'],
  standalone: false
})
export class SeverityBarComponent implements OnInit {
  @Input() severityNumber: number = 0;
  @Input() severityText: string = this.translateService.instant('SEVERITY_UNKNOWN');
  @Input() ratingScaleLevels: any[] = [];
  barColor: string = ''; // default
  textColor: string = ''; // default
  severityDescription: string = '';

  constructor(private translateService: TranslateService) {}

  public ngOnInit(): void {
    const severityObj = this.ratingScaleLevels.find((item: any) => item.level === this.severityNumber);

    if (severityObj) {
      this.barColor = severityObj.htmlColorCode || '#f0f0f0';
      this.textColor = severityObj.textColor || '#000000';
      this.severityText = severityObj.label || this.severityText;
      this.severityDescription = severityObj.description || '';
    } else {
      this.barColor = '#d6d5dd';
      this.textColor = '#1e1b31';
      this.severityText = this.translateService.instant('MAP.SEVERITY-BAR.NO-RATING');
      this.severityDescription = this.translateService.instant('MAP.SEVERITY-BAR.NO-RATING-ASSOCIATED-ALERT');
    }
  }
}
